/**
 * @description Гарантирует, что скрипт AdSense загружен.
 * 1. Ищет существующий <script> в DOM (из layout.tsx)
 * 2. Если не найден — создаёт динамически
 * 3. Возвращает true когда скрипт загружен, false при ошибке
 */

import {AD_SENSE_CLIENT_ID} from '../constants';

export const ensureAdSenseScript = (): Promise<boolean> => {
  return new Promise(resolve => {
    const existingScript = document.querySelector<HTMLScriptElement>('script[src*="adsbygoogle.js"]');

    if (existingScript) {
      const w = window as Window & {adsbygoogle?: unknown[]};
      if (w.adsbygoogle && typeof w.adsbygoogle === 'object') {
        resolve(true);
        return;
      }

      const onLoad = () => resolve(true);
      const onError = () => resolve(false);
      existingScript.addEventListener('load', onLoad, {once: true});
      existingScript.addEventListener('error', onError, {once: true});

      setTimeout(() => {
        existingScript.removeEventListener('load', onLoad);
        existingScript.removeEventListener('error', onError);
        resolve(false);
      }, 5000);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_SENSE_CLIENT_ID}`;
    script.async = true;
    script.crossOrigin = 'anonymous';

    script.addEventListener('load', () => resolve(true), {once: true});
    script.addEventListener('error', () => resolve(false), {once: true});

    document.head.appendChild(script);
  });
};
